module.exports = __webpack_public_path__ + "img/SUV_disabled.340938c8.svg";